<!-- ACCESS -->
<template>
    <v-row no-gutters class="fill-height">
        <!-- // * LEFT PANEL -->
        <v-col :cols="GET_panelLayout.leftPanel">
            <v-row class="px-2 mt-2 pa-0" dense>
                <!-- // * DESCRIPTION -->
                <v-col :cols="computedCols">
                    <v-row no-gutters class="">
                        <v-col class="px-2" cols="12" xs="12" sm="12" md="12">
                            <app-text category="content-title">{{ $t(`${langPath}.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text> 
                            <app-text class="help-text" v-if="GET_help && GET_currentUser.userType === 'CONTRACTOR'" v-html="$t(`${langPath}.text.contractor`)"></app-text>
                            <app-text class="help-text" v-if="GET_help && GET_currentUser.userType !== 'CONTRACTOR'" v-html="$t(`${langPath}.text.default`)"></app-text>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * FILTERS -->
                <v-col :cols="computedCols" class="px-2">
                    <v-row dense class="d-flex justify-end">
                        <v-col cols="12" xs="12" sm="12" md="6" class="">
                            <v-text-field background-color="white" v-model="search" prepend-inner-icon="icons8-search" filled dense :label="$t(`filters.search`)" clearable hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" class="" v-if="$vuetify.breakpoint.lgAndUp && ['VM','VA','CM','CA','SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.site" :items="sites" item-text="siteName" item-value="id" filled dense clearable :label="$t(`filters.site`)" hide-details></v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" class="" v-if="$vuetify.breakpoint.lgAndUp && ['VM','VA','CM','CA','SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.organisation" :items="organisations" item-text="organisationName" item-value="id" filled dense clearable :label="$t(`filters.organisation`)" hide-details></v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" class="d-flex align-center" v-if="$vuetify.breakpoint.lgAndUp && ['VM','VA','CM','CA','SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="sortBy" :items="filteredHeaders" item-text="text" item-value="value" filled clearable dense :label="$t(`filters.sortBy`)" hide-details>
                                <template v-slot:item="data">{{ $t(`fields.${data.item.text}`) }}</template>
                                <template v-slot:selection="data">{{ $t(`fields.${data.item.text}`) }}</template>
                            </v-select>
                            <v-btn icon class="ml-2" @click="filter.sortAsc = !filter.sortAsc"><v-icon :class="{ 'icons8-down-arrow': filter.sortAsc, 'icons8-up-arrow': !filter.sortAsc }" class="text-h5"></v-icon></v-btn>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" class="d-flex align-center" v-if="$vuetify.breakpoint.lgAndUp && ['VM','VA','CM','CA','SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-text-field @click="MIX_datePicker(true, 'accessFromDate')" append-icon="mdi-calendar" :label="$t('filters.accessFromDate')" clearable v-model="filter.formattedAccessFromDate" filled hide-details background-color="white" dense></v-text-field>
                        </v-col>                        
                        <v-col cols="12" xs="12" sm="12" md="6" class="d-flex align-center" v-if="$vuetify.breakpoint.lgAndUp && ['VM','VA','CM','CA','SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-text-field @click="MIX_datePicker(true, 'accessToDate')" append-icon="mdi-calendar" :label="$t('filters.accessToDate')" clearable v-model="filter.formattedAccessToDate" filled hide-details background-color="white" dense></v-text-field>
                        </v-col>       
                    </v-row>
                </v-col>
                <!-- <v-col cols="12" class="pl-2 pr-0 d-flex align-center justify-end">
                    <div><appbutton v-if="$vuetify.breakpoint.smAndDown" :label="$t(`buttons.new`)" icon="icons8-security-pass" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="" sizeoverride="large" @click.native="openItem('', 'New', false)" /></div>
                </v-col>                 -->
                <!-- // * STATUS AND BUTTONS -->
                <v-col cols="12" class="pl-2 pr-0 d-flex align-center">
                        <!-- // * STATUS FILTER -->
                        <div v-if="['VM','VA','CM','CA','SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-btn-toggle v-model="filter.status" multiple color="white" active-class="white" background-color="lightgrey" dense >
                                <v-btn value="APPROVED"><v-icon class="success--text icons8-checkmark-yes"></v-icon><span class="success--text caption hidden-sm-and-down"  >{{ $t(`status.approved`) }}</span></v-btn>
                                <v-btn value="REJECTED"><v-icon class="warning--text text--lighten-1 icons8-high-importance"></v-icon><span class="warning--text caption hidden-sm-and-down">{{ $t(`status.rejected`) }}</span></v-btn>
                                <v-btn value="PENDING"><v-icon class="grey--text text--lighten-1 icons8-circle"></v-icon><span class="grey--text caption hidden-sm-and-down">{{ $t(`status.pending`) }}</span></v-btn>
                                <!-- <v-btn value="DRAFT"><v-icon class="grey--text text--lighten-1 icons8-inactive-state"></v-icon><span class="grey--text caption hidden-sm-and-down">{{ $t(`status.draft`) }}</span></v-btn> -->
                                <v-btn value="SUSPENDED"><v-icon class="error--text text--lighten-1  icons8-private"></v-icon><span class="error--text caption hidden-sm-and-down">{{ $t(`status.suspended`) }}</span></v-btn>
                            </v-btn-toggle>
                        </div>
                        <v-spacer v-if="$vuetify.breakpoint.smAndDown" />
                        <div><appbutton v-if="$vuetify.breakpoint.smAndDown" :label="$t(`buttons.new`)" icon="icons8-security-pass" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="" sizeoverride="medium" @click.native="openItem('', 'New', false)" /></div>
                        <!-- // * SHOW DELETED -->
                        <div class="d-flex" v-if="['DA'].includes(GET_currentUser.userLevel) && $vuetify.breakpoint.mdAndUp">
                            <v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon>
                            <v-switch @change="getTableData()" v-model="showDeleted" class="ml-1 purple--text" color="purple" inset></v-switch>  
                        </div>
                        <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />
                        <!-- // * BUTTONS -->
                        <div v-if="['CM','CA','SM','SA','DA'].includes(GET_currentUser.userLevel)" class="d-flex align-center"><appbutton :label="$t(`buttons.new`)" icon="icons8-security-pass" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="openItem('', 'New', false)" /></div>
                        <div v-if="['SA','DA'].includes(GET_currentUser.userLevel)" class="d-flex align-center pr-1">                        
                            <div v-if="$vuetify.breakpoint.mdAndUp"><appbutton :label="$t(`buttons.columns`)" icon="icons8-select-column" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="2xlOnly" @click.native="columnsDialog = true" /></div>
                            <div v-if="$vuetify.breakpoint.mdAndUp"><appbutton :label="$t(`buttons.export`)" icon="icons8-export-csv" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="2xlOnly" @click.native="mix_exportDocuments(headersCSV,'Site Access',formatExport)" /></div>
                        </div>
                </v-col>

                <!-- // * TABLE -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.mdAndUp" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table
                        :headers="filteredHeaders"
                        :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                        :items="computedTableData"
                        item-key="id"
                        class="elevation-0"
                        hide-default-header
                        :search="search"
                        >
                        <!-- // HEADERS -->                        
                        <template v-slot:header="{ props }">
                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                {{ $t(`fields.${head.text}`) }}
                            </th>
                        </template>     
                        <!-- // STATUS -->             
                        <template v-slot:[`item.accessStatus`]="{ item }">
                            <v-icon v-if="item.accessStatus === 'APPROVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                            <v-icon v-if="item.accessStatus === 'REJECTED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-high-importance"></v-icon>
                            <v-icon v-if="item.accessStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                            <v-icon v-if="item.accessStatus === 'DRAFT'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-inactive-state"></v-icon>
                            <v-icon v-if="item.accessStatus === 'SUSPENDED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 error--text icons8-private"></v-icon>
                        </template>
                        <!-- // NAME -->
                        <template v-slot:[`item.accessName`]="{ item }">
                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="purple--text d-inline-block text-truncate" style="max-width: 200px;"><v-icon class="purple--text">icons8-trash</v-icon> {{ item.accessName}}</span>
                            <span v-else>{{ item.accessName }}</span>
                        </template>
                        <!-- // SITE -->
                        <template v-slot:[`item.site`]="{ item }">
                            <span>{{ item.site }}</span>
                        </template>
                        <!-- // ORGANISATION -->
                        <template v-slot:[`item.organisation`]="{ item }">
                            <span>{{ item.organisation }}</span>
                        </template>       
                        <!-- // Persons Count -->
                        <template v-slot:[`item.users`]="{ item }">
                            <span>{{ item.users }}</span>
                        </template>   
                        <!-- // HOST -->
                        <template v-slot:[`item.accessHost`]="{ item }">
                            <div @click="MIX_popupUser(item.accessHost.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.accessHost.userName }}
                            </div>
                        </template>                                                                    
                        <!-- // ACTION -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn @click="openItem(item.id, 'View', false)" depressed class="black--text white">Open<v-icon>mdi-chevron-right</v-icon></v-btn>
                        </template>
                        <!-- // CREATED USER DATA -->
                        <template v-slot:[`item.createdUserData`]="{ item }">
                            <div v-if="item.createdUserData !== '' && item.createdUserData !== undefined && item.createdUserData !== null" @click="MIX_popupUser(item.createdUserData.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.createdUserData.userName }}
                            </div>
                        </template>                                                        
                        <!-- // MODIFIED USER DATA -->
                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                            <div v-if="item.modifiedUserData !== '' && item.modifiedUserData !== undefined && item.modifiedUserData !== null" @click="MIX_popupUser(item.modifiedUserData.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.modifiedUserData.userName }}
                            </div>
                        </template>
                        <!-- // DELETE USER DATA -->
                        <template v-slot:[`item.deleteUserData`]="{ item }">
                            <div v-if="item.deleteUserData !== '' && item.deleteUserData !== undefined && item.deleteUserData !== null" @click="MIX_popupUser(item.deleteUserData.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.deleteUserData.userName }}
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
                <!-- // * MOBILE CARDS / Instead of Table -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.smAndDown" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-row no-gutters>
                        <v-col cols="12" xs="12" class="my-1 pa-1 white tablecard" v-for="item in computedTableData" :key="item.id" @click="openItem(item.id, 'View', false)">
                            <v-row class="d-flex align-center justify-center pa-3 fill-height" no-gutters >
                                <v-col cols="2" class="">
                                    <!-- // TODO MEED TO MAKE THIS GENERIC -->
                                    <v-icon v-if="item.accessStatus === 'APPROVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                    <v-icon v-if="item.accessStatus === 'REJECTED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-high-importance"></v-icon>
                                    <v-icon v-if="item.accessStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                                    <v-icon v-if="item.accessStatus === 'DRAFT'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 error--text icons8-private"></v-icon>                                    
                                    <v-icon v-if="item.accessStatus === 'SUSPENDED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 error--text icons8-private"></v-icon>                                    
                                </v-col>
                                <v-col cols="7" class="d-flex flex-column justify-center">
                                    <div style="margin: 0px !important; line-height: 16px !important;" class="noselect"><span class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.accessName }}</span></div>
                                    <div style="" class="caption grey--text text--darken-1 noselect">{{ item.site }}</div>
                                    <div class="caption noselect">{{ item.startDate }} <span v-if="item.endDate !== item.startDate"> - {{ item.endDate }}</span></div>
                                </v-col>
                                <v-col cols="3" class="text-right"><v-icon @click="openItem(item.id, 'View', false)" depressed class="black--text white">mdi-chevron-right</v-icon></v-col>
                            </v-row>
                         </v-col>
                    </v-row>
                </v-col>
                <!-- // * COPYRIGHT -->
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 copyright">
                    <appcopyright  />
                </v-col>
            </v-row>
        </v-col>
        <!-- // * RIGHT PANEL -->
        <!-- // * DYNAMIC COMPONENT PANEL -->
        <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
            mode="out-in">
            <rightpanel></rightpanel>
        </transition>
        <!-- // * DYNAMIC COMPONENT DIALOG -->        
        <v-dialog v-model="columnsDialog" scrollable max-width="300px">
            <v-card>
                <v-card-title>{{$t('miscHeadings.showHideColumns')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;">
                    <v-list>
                        <v-list-item v-for="(header, index) in columnHeaders" :key="index">
                          <v-list-item-title><v-checkbox color="grey darken-1" hide-details v-model="headers[index].hidden" :false-value="true" :true-value="false" :label="$t(`fields.${header.text}`)"></v-checkbox></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer />
                    <v-btn color="primary" text @click="columnsDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>        
    </v-row>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'; // Map Actions / Getters
    export default {
        // * DATA
        data: () => ({
            collection: 'access',
            collectionTitle: 'Site Access',
            collectionItem: 'access',
            collectionItemTitle: 'Site Access',  
            langPath: 'access',
            columnsDialog: false,
            search: '', // Table Search
            sortBy: 'accessDate', // Default Table Sort By
            customWhere: [],
            filter: {
                // Default Filters
                sortAsc: false,
                status: ['APPROVED', 'REJECTED', "PENDING"],
                type: '',
                site: '',
                organisation: null,
                formattedAccessFromDate: '',
                formattedAccessToDate: ''
            },
            tableData: [], // Table Data
            headers: [ // Table Headers
                // hidden shows the initial value of the column - hidden or visible
                // hides determines if you want to hide the column on screen resize
                { text: 'status', value: 'accessStatus', sortable: false, align: 'center', hidden: false, hide: false },
                { text: 'id', value: 'id', sortable: false, align: 'left', hidden: true, hide: true },                
                { text: 'startDate', value: 'startDate', align: 'left', sortable: false, hidden: false, hide: false },                
                { text: 'endDate', value: 'endDate', align: 'left', sortable: false, hidden: false, hide: false },                
                { text: 'site', value: 'site', align: 'left', sortable: false, hidden: false, hide: false },                
                { text: 'organisation', value: 'organisation', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'project', value: 'project', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'users', value: 'users', align: 'center', sortable: false, hidden: true, hide: false },
                { text: 'name', value: 'accessName', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'host', value: 'accessHost', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'created', value: 'createdDateTime', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'createdUserData', value: 'createdUserData', align: 'left', sortable: false, hidden: false, hide: true },
                { text: 'modified', value: 'modifiedDateTime', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'modifiedUserData', value: 'modifiedUserData', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'delete', value: 'delete', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'deleteUserData', value: 'deleteUserData', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'actions', value: 'actions', align: 'right', sortable: false, sortable: false, hidden: false, hide: false },
            ],
            headersCSV: {
                id: 'Access ID',
                accessStatus: 'Status',
                startDate: 'First Day of Visit',
                endDate: 'Last Day of Visit',
                site: 'Site',
                organisation: 'Organisation',
                accessHost: 'Sponsor',
                users: 'Users',
                accessName: 'Name',
                accessDescription: 'Description',
                createdDateTime: 'Created Date and Time',
                createdUserData: 'Created By',
                modifiedDateTime: 'Modified Date and Time',
                modifiedUserData: 'Modified By',
            },
            // EXPORT
            exportData: [],
            // SITES
            sites: [],
            organisations: [],
            // LOOKUP VALUES
            accessTypes: [],
            accessSeverities: [],
            // DELETED
            showDeleted: false,
            filteredHeaders: []
        }),
        // * COMPUTED
        computed: {
            // Map Getters
            ...mapGetters({
                GET_currentUser: 'GET_currentUser',
                GET_panelLayout: 'GET_panelLayout',
                GET_lookupValues: 'GET_lookupValues',     
                GET_sites: 'GET_sites',
                GET_organisations: 'GET_organisations',   
                GET_projects: 'GET_projects',             
				GET_datePickerResult: "datePicker_store/GET_datePickerResult", // Get Date Picker Result                            
                GET_help: 'GET_help'   
            }),
            formatExport() {
                this.exportData = JSON.parse(JSON.stringify(this.computedTableData))
                return this.exportData
            },
            // // Computed Table Headers            
            // computedHeaders() {
            //     var t = this;
            //     var headers = t.headers;
            //     return (t.$filter(headers, {
            //         hidden: false, // filter headers based on initial hidden value
            //     }));
            // },
            // Remove actions from Selectable Column Headers
            columnHeaders() {
                var t = this;
                var headers = t.headers;
                return (headers.filter((header) => {
                    return header.value !== 'actions'
                }));
            },    
            // Computed Cols
            computedCols() {
                var t = this;
                var cols
                var leftPanel = t.GET_panelLayout.leftPanel
                switch (true) {
                    case (leftPanel === 12): cols = 6; break
                    case (leftPanel === 6): cols = 12; break;
                    default: cols = 12;
                }
                if (t.$vuetify.breakpoint.smAndDown) { cols = 12 }
                return cols
            },
            // Computed Table Data
            computedTableData() {
                var t = this;
                var tableData = t.tableData;


                // Filter by status
                tableData = tableData.filter(function(item) {
                    return t.filter.status.includes(item[t.collectionItem+'Status']);
                });
                // Filter by Site
                if ((t.filter.site !== '') && (t.filter.site !== undefined) && (t.filter.site !== null)) {                    
                    tableData = tableData.filter(function(item) {
                        return t.filter.site === item.site;
                    });
                }

//                 if (['CA', 'CM', 'CS', 'CU'].includes(t.GET_currentUser.userLevel)) {
//                     tableDataList = tableDataList.filter(function(item) {
// //                            console.log(`${item.createdUserData.userId} - ${t.GET_currentUser.id}`);
//                         return (
//                             item.users.includes(t.GET_currentUser.id) || (
//                             item.createdUserData.userId.includes(t.GET_currentUser.id)))
//                     })
//                 }              
                // Filter by Pass From and To Dates
                if ((t.filter.formattedAccessFromDate !== '') && (t.filter.formattedAccessToDate !== '') && (t.filter.formattedAccessFromDate !== null) && (t.filter.formattedAccessToDate !== null)) {
                    tableData = tableData.filter(function(item) {
                        return (
                            (t.$moment(item.startDate, 'DD-MMM-YY').format('X') >= t.$moment(t.filter.formattedAccessFromDate, 'DD-MMM-YY').format('X'))
                            && (t.$moment(item.endDate, 'DD-MMM-YY').format('X') <= t.$moment(t.filter.formattedAccessToDate, 'DD-MMM-YY').format('X')))
                    });
                }
                // Filter by Search Mobile                
                if (t.search !== '' && t.$vuetify.breakpoint.smAndDown) {
                    tableData = tableData.filter(function(item) {
                        var itemName = item[t.collectionItem+'Name'].toUpperCase();
                        var search = t.search.toUpperCase();
                        return itemName.includes(search)
                    });
                }
                 // TODO FILTER REQUIORED FOR PASSES FROM AND PASSES TO
                var tableDataList = tableData.map(e => {
                    return {
                        id: e.id,
                        accessStatus: e.accessStatus,
                        startDate: t.MIX_formatDateTime(e.startDate, 'x', 'DD-MMM-YY'),
                        endDate: t.MIX_formatDateTime(e.endDate, 'x', 'DD-MMM-YY'),
                        site: e.site.siteName,
                        organisation: e.organisation.organisationName,
                        accessHost: e.accessHost,
                        users: e.users.length,
                        project: e.project && e.project.projectName,
                        accessName: e.accessName,
                        accessDescription: e.accessDescription,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
               
                // Filter by Organisation
                if ((t.filter.organisation !== '') && (t.filter.organisation !== undefined) && (t.filter.organisation !== null)){                    
                    tableDataList = tableDataList.filter(function(item) {
                        return t.filter.organisation === item.organisation;
                    });
                }    
                // Sort the Table by the Field in the Sort By Filter
                var sortResults = t.$sortBy(tableDataList, t.sortBy)
                if (!t.filter.sortAsc) {sortResults.reverse()}
                return (sortResults);      
            }
        },
        // * WATCH
        watch: {
            GET_currentUser: {
                handler() {
                    this.getTableData();
                }, deep: true
            },
            GET_datePickerResult: {
				// Watch for a change in the Date Picker Result and Update the Project Start or End Date based on the Date Picker Result Field
				handler() {
                    // console.log('GET_datePickerResult = ' + JSON.stringify(this.GET_datePickerResult, null, 2))
					switch (this.GET_datePickerResult.field) {
						case "accessFromDate":
                            // this.accessFromDate = this.GET_datePickerResult.value;
							this.filter.formattedAccessFromDate = this.MIX_formatDateTime(this.$moment(this.GET_datePickerResult.value, 'x').startOf('day').format('x'), "x", "DD-MMM-YY"); // Update the Formatted Project Start Date
							break;
						case "accessToDate":
                            // this.accessToDate = this.GET_datePickerResult.value;
							this.filter.formattedAccessToDate = this.MIX_formatDateTime(this.$moment(this.GET_datePickerResult.value, 'x').endOf('day').format('x'), "x", "DD-MMM-YY"); // Update the Formatted Project Start Date
							break;
						default:
							//do nothing
							break;
					}
				},
				deep: true,
			},            
            GET_panelLayout: {
                handler() {
                    let t = this;
                    if (t.GET_panelLayout.rightPanel === 6) {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hide === false && header.hidden === false);
                        });
                    } else {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hidden === false);
                        }) 
                    }
                }, deep: true,
            },
            headers: {
                handler() {
                    let t = this;
                     t.filteredHeaders = t.headers.filter((header) => {
                         return (header.hidden === false)
                     });
                }, deep: true,
            }            
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openAccess'}),
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                t.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM
            openItem: async function(id, process, popup) {
                var t = this;
                var item = {}                
                t.dynamicComponentKey++; 
                item.process = process;
                item.popup = popup;
                // console.log('item = ' + JSON.stringify(item, null, 2))
                if (item.process !== 'New') {
                    var itemResult = await t.MIX_readDocumentById(t.collection, id)
                    item.data = itemResult.data;
                } else {
                    item.data = null;
                }
                t.ACT_openItem(item); // Open Item
                if (t.$vuetify.breakpoint.lgAndDown) {
                    t.MIX_fsDialog(true, t.collectionItemTitle, t.collectionItem);
                    t.MIX_setPanelLayout(12, 0, false, '');
                } else {
                    t.MIX_setPanelLayout(6, 6, true, t.collectionItemTitle, t.collectionItem);
                    // // * HIDE HEADERS
                    // for (var i = 0; i < t.headers.length; i++) {
                    //     if (t.headers[i].hide === true) {
                    //         t.headers[i].hidden = true;
                    //     }
                    // }
                }
                return;
            },
            // GET NOTICES SNAPSHOT METHOD
            getTableData: async function () {
                var t = this;
                var collection = t.$firebase.db.collection(t.collection)

                t.customWhere = [];
                // Filter on onganisation id if User or Supervisor
                if (['CU','CS','CM','CA','VU','VS','VM','VA'].includes(t.GET_currentUser.userLevel)) {
                    t.customWhere.push ({ key: 'organisation.organisationId', operator: '==', value: t.GET_currentUser.organisation.organisationId });
                }
                // Filter on user ID if User or Supervisor
                if (['CU','CS','CM','VU','VM','VS'].includes(t.GET_currentUser.userLevel)) {
                    t.customWhere.push ({ key: 'users', operator: 'array-contains', value: t.GET_currentUser.id });
                }
                if (JSON.stringify(t.customWhere) !== '[]') {
                    for (var i = 0; i < t.customWhere.length; i++) {
                        var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                        collection = collection.where(query.field, query.operator, query.value)   
                    }
                }
                collection.onSnapshot(function(querySnapshot) {
                    t.tableData = [];
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id;
                        if (!document.hasOwnProperty('delete')) {
                            t.tableData.push(document);
                        } else if (t.showDeleted) {
                            t.tableData.push(document);
                        } else {
                            // Do not Show Concern
                        }
                    });
                });
                return;
            },
        },
        // * MOUNTED
        async mounted() {
            // * DEFAULT MOUNTED
            var t = this;
            t.MIX_setPanelLayout(12, 0, false, ''); // Hide Right Panel
            t.updateBreadcrumbs(); // Update Breadcrumbs in Title
            // INSERT CUSTOM WHERES HERE
            // t.customWhere.push ({ key: '', operator: '==', value: '' });
            t.getTableData(); // Get Table Data            
            // * LOOKUP RELATED MOUNTED
            // LOOKUPS
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            t.accessStatus = await t.GET_lookupValues('ACCESSSTATUS');
            // GET SITES
            await t.MIX_sites(); // UPDATE SITES LIST IN STORE (id, siteName)
            t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY       
            await t.MIX_organisations();
            t.organisations = t.GET_organisations;
            // console.log("t.organisation = " + JSON.stringify(t.organisations, null, 2))

			t.organisations = t.organisations.sort((a, b) => a.organisationName.localeCompare(b.organisationName))

            // console.log("t.orgnaisations = " + JSON.stringify(t.organisations, null, 2))
            
            if (t.GET_currentUser.userType === 'CONTRACTOR' || t.GET_currentUser.userType === 'VISITOR') {
                var customwhereQuery =  [
                        {   key: 'organisation.organisationId', 'value': t.GET_currentUser.organisation.organisationId, 'operator': '==' } // MANAGER OR ADMIN
                    ];
                await t.MIX_projects(customwhereQuery); // GET LIST OF ORGANISATION ONLY PROJECTS
            } else {
                await t.MIX_projects([]); // GET LIST OF ALL PROJECTS                
            }
            t.projects = t.GET_projects;
            // console.log('t.projects = ' + JSON.stringify(t.projects, null, 2))
            // * AUTO OPEN SITE IF PATH CONTAINS SITEID
            if ((window.location.pathname !== `/${t.collection}` && window.location.pathname !== `/${t.collection}/`)) {
                var urlPath = window.location.pathname.split('/');
                var id = urlPath[2];
                // TODO NEED TO ADD THIS TO OTHER SECTIONS
                if (id === 'new') {
                    t.openItem('', 'New', false)
                } else {
                    t.openItem(id, 'View', false)
                }
            }                    
        },
    }
</script>